import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import FullPageLoader from "@Components/FullPageLoader";

const Editorial = loadable(() => import("./Editorial"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <Editorial {...props} />
  </ErrorBoundary>
);
